// extracted by mini-css-extract-plugin
export default {"parent_div":"index_parent_div__Q3Ddy","document_viewer":"index_document_viewer__fT7U5","document_viewer_page":"index_document_viewer_page__otq8a"};